import Seo from "@/components/Seo";
import NavBar from "@/components/NavBar";
import Hero from "@/components/Hero";
import ArtistMarquee from "@/components/Marquee";
import StatsBand from "@/components/StatsBand";
import Highlights from "@/components/Highlights";
import UpcomingShows from "@/components/UpcomingShows";
import Partners from "@/components/Partners";
import CTABand from "@/components/CTABand";
import Footer from "@/components/Footer";
import { useLang } from "@/lib/i18n";

export default function Home() {
  const { lang } = useLang();
  return (
    <div className="bg-[#050505] min-h-screen">
      <Seo
        title={lang === "zh" ? "DFE 娛樂夢工廠 | 演唱会制作 · 艺人管理 · 音乐节策划" : "Dream Factory Entertainment | Concert Production & Artist Management"}
        description={
          lang === "zh"
            ? "娛樂夢工廠 DFE — 马来西亚演唱会制作、音乐节策划与艺人管理公司，自 2009 年。BLACK EYED PEAS、DAESUNG、TAEYANG 幕后团队。Where Music Meets Dreams."
            : "Dream Factory Entertainment (DFE) — Malaysia's concert production, festival and artist management company since 2009. Where Music Meets Dreams."
        }
      />
      <NavBar />
      <main>
        <Hero />
        <ArtistMarquee />
        <StatsBand />
        <Highlights />
        <UpcomingShows />
        <Partners />
        <CTABand />
      </main>
      <Footer />
    </div>
  );
}
